<template>
  <div>
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <!--                <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">-->
        <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
        <!--                    <el-breadcrumb-item :to="{ path: '/' }">系统配置</el-breadcrumb-item>-->
        <!--                    <el-breadcrumb-item>手动输入</el-breadcrumb-item>-->
        <!--                </el-breadcrumb>-->
        <nav-bar></nav-bar>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('ManualInputRadings')" name="first">
            <el-form
                ref="formselect"
                :model="formselect"
                label-width="80px"
                class="queryform_div"
            >
              <el-form-item :label="$t('EquipmentType')" style="width: auto">
                <el-select
                    :placeholder="$t('el.select.placeholder')"
                    v-model="formselect.deviceType"
                    filterable
                    class="queryform"
                >
                  <el-option value="ElectricMeter" :label="$t('Meter')"></el-option>
                  <el-option value="SteamMeter" :label="$t('SteamTable')"></el-option>
                  <el-option value="WaterMeter" :label="$t('WaterMeter')"></el-option>
                  <el-option
                      value="NaturalGasMeter"
                      :label="$t('NaturalGasMeter')"
                  ></el-option>
                  <el-option value="Transformer" :label="$t('transformer')"></el-option>
                  <!-- <el-option value="TemHumSensor" label="温湿度计"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('EquipmentCode')" style="width: auto">
                <el-input
                    class="queryform"
                    v-model="formselect.deviceCode"
                    placeholder=""
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="账单号">
                               <el-input class="queryform" v-model="formselect.billNumber" placeholder=""></el-input>
                           </el-form-item> -->
              <el-form-item :label="$t('Month')" style="width: auto">
                <el-date-picker
                    v-model="formselect.yearMonth"
                    type="month"
                    value-format="yyyy-MM"
                    :placeholder="$t('el.select.placeholder')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="width: auto">
                <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                <el-button @click="reset">{{ $t('Reset') }}</el-button>
              </el-form-item>
            </el-form>
            <template>
              <el-button
                  type="primary"
                  icon="el-icon-circle-plus-outline"
                  @click="addMinput"
                  v-if="judge('ManualInput_CreateManualValue')"
                  style="margin-bottom: 10px"
              >{{ $t('Add') }}
              </el-button>
              <el-table
                  ref="multipleTable"
                  :data="tableData1"
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%; min-height: 220px"
              >
                <el-table-column type="index" :label="$t('SN')" width="50">
                </el-table-column>
                <el-table-column
                    prop="deviceCode"
                    :label="$t('EquipmentCode')"
                    min-width="20%"
                >
                </el-table-column>
                <el-table-column
                    prop="deviceName"
                    :label="$t('DeviceName')"
                    min-width="20%"
                >
                </el-table-column>
                <el-table-column
                    prop="deviceType"
                    :label="$t('EquipmentType')"
                    min-width="12%"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.deviceType == 'ElectricMeter'"
                    >{{ $t('electricityMeter') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'SteamMeter'"
                    >{{ $t('SteamTable') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'WaterMeter'"
                    >{{ $t('WaterMeter') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'NaturalGasMeter'"
                    >{{ $t('NaturalGasMeter') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'Transformer'"
                    >{{ $t('transformer') }}</label
                    >
                    <!-- <label v-else-if="scope.row.deviceType=='TemHumSensor'">温湿度计</label> -->
                  </template>
                </el-table-column>
                <el-table-column prop="yearMonth" :label="$t('Month')" min-width="10%">
                </el-table-column>
                <el-table-column
                    prop="curValueDate"
                    :label="$t('ReadingDate')"
                    min-width="10%"
                >
                </el-table-column>
                <el-table-column
                    prop="curValue"
                    :label="$t('CurrentReading')"
                    min-width="13%"
                >
                </el-table-column>
                <el-table-column
                    prop="lastValue"
                    :label="$t('LastReading')"
                    min-width="13%"
                >
                </el-table-column>
                <el-table-column fixed="right" :label="$t('Action')" min-width="20%">
                  <template slot-scope="scope">
                    <el-button
                        v-if="judge('ManualInput_UpdateManualValue')"
                        @click="editMinput(scope.row, true)"
                        type="primary"
                        size="small"
                    >{{ $t('Edit') }}
                    </el-button>
                    <template v-if="judge('ManualInput_DeleteManualValue')">
                      <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('Delete')"
                          :cancelButtonText="$t('Cancel')"
                          @onConfirm="delMinput(scope.row.id)"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('DeleteConfirm')"
                      >
                        <el-button
                            size="mini"
                            type="danger"
                            slot="reference"
                            style="margin-left: 10px"
                        >{{ $t('Delete') }}
                        </el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  :page-size="10"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next"
                  :total="total"
              >
              </el-pagination>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="$t('ManualInputBills')" name="second">
            <el-form
                ref="formselect"
                :model="formselect"
                label-width="80px"
                class="queryform_div"
            >
              <el-form-item :label="$t('EquipmentType')" style="width: auto">
                <el-select
                    :placeholder="$t('el.select.placeholder')"
                    v-model="formselect.deviceType"
                    filterable
                    class="queryform"
                >
                  <el-option value="ElectricMeter" :label="$t('Meter')"></el-option>
                  <el-option value="SteamMeter" :label="$t('SteamTable')"></el-option>
                  <el-option value="WaterMeter" :label="$t('WaterMeter')"></el-option>
                  <el-option
                      value="NaturalGasMeter"
                      :label="$t('NaturalGasMeter')"
                  ></el-option>
                  <el-option value="Transformer" :label="$t('transformer')"></el-option>
                  <!-- <el-option value="TemHumSensor" label="温湿度计"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('EquipmentCode')" style="width: auto">
                <el-input
                    class="queryform"
                    v-model="formselect.deviceCode"
                    placeholder=""
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('BillNumber')" style="width: auto">
                <el-input
                    class="queryform"
                    v-model="formselect.billNumber"
                    placeholder=""
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('Month')" style="width: auto">
                <el-date-picker
                    v-model="formselect.yearMonth"
                    type="month"
                    value-format="yyyy-MM"
                    :placeholder="$t('el.select.placeholder')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="width: auto">
                <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                <el-button @click="reset">{{ $t('Reset') }}</el-button>
              </el-form-item>
            </el-form>
            <template>
              <el-button
                  type="primary"
                  icon="el-icon-circle-plus-outline"
                  @click="addBinput"
                  v-if="judge('ManualInput_CreateManualBill')"
                  style="margin-bottom: 10px"
              >{{ $t('Add') }}
              </el-button>

              <el-table
                  ref="multipleTable"
                  :data="tableData2"
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%; min-height: 220px"
              >
                <el-table-column type="index" :label="$t('SN')" width="50">
                </el-table-column>
                <el-table-column
                    prop="deviceCode"
                    :label="$t('EquipmentCode')"
                    min-width="17%"
                >
                </el-table-column>
                <el-table-column
                    prop="deviceName"
                    :label="$t('DeviceName')"
                    min-width="15%"
                >
                </el-table-column>
                <el-table-column
                    prop="deviceType"
                    :label="$t('EquipmentType')"
                    min-width="14%"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.deviceType == 'ElectricMeter'"
                    >{{ $t('electricityMeter') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'SteamMeter'"
                    >{{ $t('SteamTable') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'WaterMeter'"
                    >{{ $t('WaterMeter') }}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'NaturalGasMeter'"
                    >{{$t('NaturalGasMeter')}}</label
                    >
                    <label v-else-if="scope.row.deviceType == 'Transformer'"
                    >{{ $t('transformer') }}</label
                    >
                    <!-- <label v-else-if="scope.row.deviceType=='TemHumSensor'">温湿度计</label> -->
                  </template>
                </el-table-column>
                <el-table-column prop="yearMonth" :label="$t('Month')" min-width="10%">
                </el-table-column>
                <el-table-column
                    prop="curValue"
                    :label="$t('CurrentMonthReading')"
                    min-width="11%"
                >
                </el-table-column>
                <el-table-column
                    prop="includingPriceMonth"
                    :label="$t('CurrentMonth PriceincludingTax')"
                    min-width="11%"
                >
                </el-table-column>
                <el-table-column
                    prop="excludingPriceMonth"
                    :label="$t('CurrentMonth PriceexcludingTax')"
                    min-width="11%"
                >
                </el-table-column>
                <el-table-column
                    prop="billNumber"
                    :label="$t('BillNumber')"
                    min-width="13%"
                >
                </el-table-column>
                <el-table-column
                    prop="billDate"
                    :label="$t('BillDate')"
                    min-width="13%"
                >
                </el-table-column>
                <el-table-column fixed="right" :label="$t('Action')" min-width="22%">
                  <template slot-scope="scope">
                    <el-button
                        v-if="judge('ManualInput_UpdateManualBill')"
                        @click="editBinput(scope.row, true)"
                        type="primary"
                        size="mini" 
                    >{{ $t('Edit') }}
                    </el-button>
                    <template v-if="judge('ManualInput_DeleteManualBill')">
                      <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('Delete')"
                          :cancelButtonText="$t('Cancel')"
                          @onConfirm="delMinput(scope.row.id)"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('DeleteConfirm')"
                      >
                        <el-button
                            size="mini"
                            type="danger"
                            slot="reference"
                            style="margin-left: 10px"
                        >{{ $t('Delete') }}
                        </el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  :page-size="10"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next"
                  :total="total"
              >
              </el-pagination>
            </template>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-scrollbar>

    <el-dialog
        :title="$t('Settings')"
        :visible.sync="dialogAddReading"
        width="70%"
        top="10vh"
    >
      <el-form ref="Readingform" :model="Readingform" label-width="150px">
        <el-row :gutter="24">
          <areaSelect1
              v-if="showSelect == 'add'"
              :hasDeviceName="false"
              :level="level"
              :deviceType="deviceType"
              :formArea="formArea"
              :enablesys="'1'"
              @areaList="getAreaList"
          ></areaSelect1>
          <div id="showDiv" v-if="showSelect == 'edit'">
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item :label="$t('City')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getFac()"
                    v-model="Readingform.cityId"
                    style="width: 100%; max-width: 220px"
                >
                  <el-option
                      v-for="(item, index) in area"
                      :key="'inx1' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item :label="$t('Campus')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getBuild()"
                    v-model="Readingform.factoryId"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in facList"
                      :key="'inx21' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <el-form-item :label="$t('Building')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getLab()"
                    v-model="Readingform.buildingId"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in building"
                      :key="'inx3' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('EquipmentType')">
              <el-select
                  :placeholder="$t('el.select.placeholder')"
                  @change="getDeviceCode(Readingform.deviceType, false)"
                  v-model="Readingform.deviceType"
                  style="max-width: 220px;width: 100%;"
              >
                <el-option value="ElectricMeter" :label="$t('Meter')"></el-option>
                <el-option value="SteamMeter" :label="$t('SteamTable')"></el-option>
                <el-option value="WaterMeter" :label="$t('WaterMeter')"></el-option>
                <el-option value="NaturalGasMeter" :label="$t('NaturalGasMeter')"></el-option>
                <el-option value="Transformer" :label="$t('transformer')"></el-option>
                <!-- <el-option value="TemHumSensor" label="温湿度计"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('EquipmentCode')">
              <el-select
                  v-model="Readingform.deviceCode"
                  @change="getDeviceByid('Readingform')"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in labList"
                    :value="item.deviceCode"
                    :label="item.deviceName"
                    :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('DeviceName')">
              <el-input
                  :placeholder="$t('AutomaticallyGenerated')"
                  :disabled="true"
                  v-model="Readingform.deviceName"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--                    <el-col :xs="24" :sm="24" :md="12" :lg="12">-->
          <!--                        <el-form-item label="倍率">-->
          <!--                            <el-input placeholder="由设备编号自动带出" :disabled="true" v-model="Readingform.ratio"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('PreviousReadingDate')">
              <el-input
                  :placeholder="$t('AutomaticallyGenerated')"
                  :disabled="true"
                  v-model="Readingform.lastValueDate"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('LastReading')">
              <el-input
                  :placeholder="$t('AutomaticallyGenerated')"
                  :disabled="true"
                  v-model="Readingform.lastValue"
                  style="max-width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentMonth')">
              <el-date-picker
                  v-model="Readingform.yearMonth"
                  type="month"
                  value-format="yyyy-MM"
                  :placeholder="$t('SelectMonth')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentReading')">
              <el-input
                  type="number"
                  v-model="Readingform.curValue"
                  style="max-width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentDate')">
              <el-date-picker
                  v-model="Readingform.curValueDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('SelectDate')"
                  @change="getDeviceByid('Readingform')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentConsumption')">
              <!-- <el-input :disabled="true" v-model="useValue"
                                      placeholder="由本次读数减去上次读数所得"><i slot="suffix" style="font-style:normal;margin-right: 10px;">KWh</i></el-input> -->

              <el-input
                  v-if="Readingform.deviceType == 'ElectricMeter'"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KWh</i
              ></el-input
              >
              <el-input
                  v-else-if="Readingform.deviceType == 'SteamMeter'"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >Ton</i
              ></el-input
              >
              <el-input
                  v-else-if="Readingform.deviceType == 'WaterMeter'"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >Ton</i
              ></el-input
              >
              <el-input
                  v-else-if="Readingform.deviceType == 'NaturalGasMeter'"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >M³</i
              ></el-input
              >
              <el-input
                  v-else-if="Readingform.deviceType == 'Transformer'"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KVA</i
              ></el-input
              >
              <el-input
                  v-else
                  type="number"
                  :disabled="true"
                  v-model="useValue"
                  :placeholder="$t('ReadingToObtain')"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KWh</i
              ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('UpdateTime')">
              <el-input
                  v-model="Readingform.nowTime"
                  :placeholder="$t('AfterSubmission')"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" style="text-align: center">
            <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
            <el-button @click="windowClose">{{ $t('Cancel') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
        :title="$t('Settings')"
        :visible.sync="dialogAddBill"
        width="70%"
        top="10vh"
    >
      <el-form ref="Readingform" :model="Readingform" label-width="150px">
        <el-row :gutter="24">
          <areaSelect1
              v-if="showSelect1 == 'add'"
              :hasDeviceName="false"
              :level="level"
              :deviceType="deviceType"
              :formArea="formArea"
              :enablesys="'1'"
              @areaList="getAreaList"
          ></areaSelect1>
          <div id="showDiv1" v-if="showSelect1 == 'edit'">
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item :label="$t('City')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getFac()"
                    v-model="Billform.cityId"
                    style="width: 100%; max-width: 220px"
                >
                  <el-option
                      v-for="(item, index) in area"
                      :key="'inx1' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item :label="$t('Campus')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getBuild()"
                    v-model="Billform.factoryId"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in facList"
                      :key="'inx21' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <el-form-item :label="$t('Building')">
                <el-select
                    :disabled="true"
                    :placeholder="$t('el.select.placeholder')"
                    @change="getLab()"
                    v-model="Billform.buildingId"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in building"
                      :key="'inx3' + index"
                      :value="item.value"
                      :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('EquipmentType')">
              <el-select
                  :placeholder="$t('el.select.placeholder')"
                  @change="getDeviceCode(Billform.deviceType, false)"
                  v-model="Billform.deviceType"
                  style="max-width: 220px;width: 100%;"
              >
                <!--                                <el-option value="all" label="全部"></el-option>-->
                <el-option value="ElectricMeter" :label="$t('Meter')"></el-option>
                <el-option value="SteamMeter" :label="$t('SteamTable')"></el-option>
                <el-option value="WaterMeter" :label="$t('WaterMeter')"></el-option>
                <el-option value="NaturalGasMeter" :label="$t('NaturalGasMeter')"></el-option>
                <el-option value="Transformer" :label="$t('transformer')"></el-option>
                <!-- <el-option value="TemHumSensor" label="温湿度计"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('EquipmentCode')">
              <el-select
                  v-model="Billform.deviceCode"
                  @change="getDeviceByid('Billform')"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in labList"
                    :value="item.deviceCode"
                    :label="item.deviceName"
                    :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('DeviceName')">
              <el-input
                  :placeholder="$t('AutomaticallyGenerated')"
                  :disabled="true"
                  v-model="Billform.deviceName"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--                    <el-col :xs="24" :sm="24" :md="12" :lg="12">-->
          <!--                        <el-form-item label="倍率">-->
          <!--                            <el-input placeholder="由设备编号自动带出" :disabled="true" v-model="Readingform.ratio"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <!--                    <el-col :xs="24" :sm="24" :md="12" :lg="12">-->
          <!--                        <el-form-item label="上次读数日期">-->
          <!--                            <el-input placeholder="由设备编号自动带出" :disabled="true"-->
          <!--                                      v-model="Billform.lastValueDate"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <!--                    <el-col :xs="24" :sm="24" :md="12" :lg="12">-->
          <!--                        <el-form-item label="上次读数">-->
          <!--                            <el-input placeholder="由设备编号自动带出" :disabled="true"-->
          <!--                                      v-model="Billform.lastValue"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentMonth')">
              <el-date-picker
                  v-model="Billform.yearMonth"
                  type="month"
                  value-format="yyyy-MM"
                  :placeholder="$t('SelectMonth')"
                  @change="getDeviceByid('Billform')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentConsumption')">
              <el-input
                  v-if="Billform.deviceType == 'ElectricMeter'"
                  type="number"
                  v-model="Billform.curValue"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KWh</i
              ></el-input
              >
              <el-input
                  v-else-if="Billform.deviceType == 'SteamMeter'"
                  type="number"
                  v-model="Billform.curValue"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >Ton</i
              ></el-input
              >
              <el-input
                  v-else-if="Billform.deviceType == 'WaterMeter'"
                  type="number"
                  v-model="Billform.curValue"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >Ton</i
              ></el-input
              >
              <el-input
                  v-else-if="Billform.deviceType == 'NaturalGasMeter'"
                  type="number"
                  v-model="Billform.curValue"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >M³</i
              ></el-input
              >
              <el-input
                  v-else-if="Billform.deviceType == 'Transformer'"
                  type="number"
                  v-model="Billform.curValue"
                  style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KVA</i
              ></el-input
              >
              <el-input v-else type="number" v-model="Billform.curValue"
                        style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >KWh</i
              ></el-input
              >
            </el-form-item>
          </el-col>
          <!--                    <el-col :xs="24" :sm="24" :md="12" :lg="12">-->
          <!--                        <el-form-item label="本次读数日期">-->
          <!--                            <el-date-picker v-model="Billform.curValueDate"-->
          <!--                                            type="date"-->
          <!--                                            :disabled="true"-->
          <!--                                            value-format="yyyy-MM-dd"-->
          <!--                                            placeholder="选择日期" style="width:120px">-->
          <!--                            </el-date-picker>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentMonth PriceincludingTax')">
              <el-input type="number" v-model="Billform.includingPriceMonth"
                        style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >{{ $t('yuan') }}</i
              ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('CurrentMonth PriceexcludingTax')">
              <el-input type="number" v-model="Billform.excludingPriceMonth"
                        style="max-width: 220px"
              ><i slot="suffix" style="font-style: normal; margin-right: 10px"
              >{{ $t('yuan') }}</i
              ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('BillNumber')">
              <el-input
                  type="number"
                  v-model="Billform.billNumber"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('BillDate')">
              <el-date-picker
                  v-model="Billform.billDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('SelectDate')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item :label="$t('UpdateTime')">
              <el-input
                  v-model="Billform.nowTime"
                  :placeholder="$t('AfterSubmission')"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" style="text-align: center">
            <el-button type="success" @click="onSubmitBill">{{ $t('Confirm') }}</el-button>
            <el-button @click="windowClose">{{ $t('Cancel') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getISOtime, fancha} from "../../utils/util";

import {
  GetAllManualInputService,
  CreateManualInputService,
  DeleteManualInputService,
  GetByDeviceId,
  GetByDeviceTypeCode,
  UpdateManualInputService,
} from "../../api/api";
import {getDeviceNameByid} from "../../utils/util";
import {judgePermission} from "../../utils/util";
import areaSelect1 from "../../components/content/maintabber/areaSelect1";

export default {
  name: "Manual",
  components: {
    areaSelect1,
  },
  data() {
    return {
      area: JSON.parse(sessionStorage.getItem("area")),
      facList: [],
      building: [],
      labList: [],
      showSelect: "add",
      showSelect1: "add",
      labList: [],
      deviceType: "",
      activeName: "first",
      dialogAddBill: false,
      dialogAddReading: false,
      loading: false,
      tableData1: [],
      tableData2: [],
      formselect: {
        deviceType: "",
        deviceId: "",
        deviceCode: "",
        billNumber: "",
        yearMonth: "",
      },
      level: 3,
      deviceType: "",
      formArea: {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      },
      formselect1: {
        cityId: "",
        factoryId: "",
        buildingId: "",
        deviceTypeCode: "",
      },
      Readingform: {
        id: "",
        deviceType: "",
        deviceName: "",
        deviceId: "",
        lastValueDate: "",
        lastValue: "0",
        yearMonth: "",
        curValue: "",
        curValueDate: "",
        curUsage: "",
        nowTime: "",
        cityId: "",
        factoryId: "",
        buildingId: "",
      },
      Billform: {
        id: "",
        deviceType: "",
        deviceName: "",
        deviceId: "",
        lastValueDate: "",
        lastValue: "",
        includingPriceMonth: "",
        excludingPriceMonth: "",
        yearMonth: "",
        curValue: "",
        curValueDate: "",
        curUsage: "",
        nowTime: "",
        billNumber: "",
        billDate: "",
        cityId: "",
        factoryId: "",
        buildingId: "",
      },
      pageSize: 10,
      SkipCount: 0,
      total: 0,
      clickBtn: "",
    };
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    useValue: function () {
      var data = this.Readingform;
      data.curUsage = this.accSub(data.curValue, data.lastValue);
      return Number(data.curUsage);
    },
  }),
  mounted() {
    this.getData();
  },
  methods: {
    getAreaList(e) {
      this.formselect1 = {...this.formselect1, ...e.Valueform};
      if (this.formselect1.DeviceName) {
        //this.selectByKeyword()
      }
    },
    accSub(arg1, arg2) {
      if (isNaN(arg1)) {
        arg1 = 0;
      }
      if (isNaN(arg2)) {
        arg2 = 0;
      }
      arg1 = Number(arg1);
      arg2 = Number(arg2);

      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    judge(e) {
      return judgePermission(e);
    },
    getDeviceCode(deviceTypeCode, boolvalue) {

      deviceTypeCode;
      var that = this;
      that.formselect1.deviceTypeCode = deviceTypeCode;
      var data = that.formselect1;
      GetByDeviceTypeCode(data).then((res) => {
        if (res.success) {
          that.labList = JSON.parse(JSON.stringify(res.result));
          if (this.Readingform || this.Billform) {
            if (!boolvalue) {
              this.Readingform.deviceCode = "";
              this.Readingform.id = "";
              this.Readingform.deviceName = "";
              this.Readingform.lastValueDate = "";
              this.Readingform.lastValue = "0";
              this.Readingform.yearMonth = "";
              this.Readingform.curValue = "";
              this.Readingform.curValueDate = "";
              this.Readingform.curUsage = "";
              this.Readingform.nowTime = "";
            }

            if (!boolvalue) {
              this.Billform.deviceCode = "";
              this.Billform.deviceName = "";
              this.Billform.lastValueDate = "";
              this.Billform.lastValue = "";
              this.Billform.includingPriceMonth = "";
              this.Billform.excludingPriceMonth = "";
              this.Billform.yearMonth = "";
              this.Billform.curValue = "";
              this.Billform.curValueDate = "";
              this.Billform.curUsage = "";
              this.Billform.nowTime = "";
              this.Billform.billNumber = "";
              this.Billform.billDate = "";
            }
          }
        }
      });
    },
    getNowDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDay();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var second = date.getSeconds();
      var nowDate = `${year}-${month}-${day} ${hours}:${minutes}:${second}`;
      return getISOtime(nowDate);
    },
    reset() {
      this.formselect = {
        deviceType: "",
        deviceId: "",
        deviceCode: "",
        billNumber: "",
        yearMonth: "",
      };
      this.getData();
      this.showSelect = "add";
      this.showSelect1 = "add";
    },
    editMinput(e, boolvalue) {
  
      this.showSelect = "edit";
      this.dialogAddReading = true;
      this.Readingform = JSON.parse(JSON.stringify(e));
      this.Readingform.lastValueDate = "";
      this.clickBtn = "edit";
      this.getDeviceCode(this.Readingform.deviceType, boolvalue);
      this.getDeviceByid("Readingform");

      var data = fancha(e.deviceId);

      for (var i in data) {
        switch (i) {
          case "0":
            this.Readingform.cityId = this.area[data[i]].value;
            this.facList = this.area[data[i]].children;
            break;
          case "1":
            this.Readingform.factoryId = this.facList[data[i]].value;
            this.building = this.facList[data[i]].children;
            break;
          case "2":
            this.Readingform.buildingId = this.building[data[i]].value;
            this.labList = this.building[data[i]].children;
            break;
          case "3":
            this.Readingform.LabId = this.labList[data[i]].value;
            this.deviveList = this.labList[data[i]].children;
            break;
        }
      }
    },
    editBinput(e, boolvalue) {
      this.showSelect1 = "edit";
      this.dialogAddBill = true;
      this.Billform = JSON.parse(JSON.stringify(e));
      this.Billform.lastValueDate = "";
      this.clickBtn = "edit";
      this.getDeviceCode(this.Billform.deviceType, boolvalue);
      this.getDeviceByid("Billform");
      var data = fancha(e.deviceId);

      for (var i in data) {
        switch (i) {
          case "0":
            this.Billform.cityId = this.area[data[i]].value;
            this.facList = this.area[data[i]].children;
            break;
          case "1":
            this.Billform.factoryId = this.facList[data[i]].value;
            this.building = this.facList[data[i]].children;
            break;
          case "2":
            this.Billform.buildingId = this.building[data[i]].value;
            this.labList = this.building[data[i]].children;
            break;
          case "3":
            this.Billform.LabId = this.labList[data[i]].value;
            this.deviveList = this.labList[data[i]].children;
            break;
        }
      }
    },
    addMinput() {
      this.dialogAddReading = true;
      this.showSelect = "add";
      this.clickBtn = "add";
      this.Readingform = {
        id: "",
        deviceType: "",
        deviceName: "",
        deviceId: "",
        lastValueDate: "",
        lastValue: "0",
        yearMonth: "",
        curValue: "",
        curValueDate: "",
        curUsage: "",
        nowTime: "",
      };
    },
    addBinput() {
      this.dialogAddBill = true;
      this.showSelect1 = "add";
      this.clickBtn = "add";
      this.Billform = {
        id: "",
        deviceType: "",
        deviceName: "",
        deviceId: "",
        lastValueDate: "",
        lastValue: "",
        includingPriceMonth: "",
        excludingPriceMonth: "",
        yearMonth: "",
        curValue: "",
        curValueDate: "",
        curUsage: "",
        nowTime: "",
      };
    },
    getNowTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDay();
      //this.Readingform.yearMonth = `${year}-${month}`
      //this.Readingform.curValueDate = `${year}-${month}-${day}`
      //this.Billform.yearMonth = `${year}-${month}`
      //this.Billform.curValueDate = `${year}-${month}-${day}`
    },
    getDeviceByid(e) {
   
      this.getNowTime();
      var data = {code: "", yearMonth: "", inputType: "", curValueDate: ""},
          that = this;
      if (e == "Readingform") {
        data.code = this.Readingform.deviceCode;
        data.yearMonth = this.Readingform.yearMonth;
        data.inputType = "mInput";
        data.curValueDate = this.Readingform.curValueDate;
      } else {
        data.code = this.Billform.deviceCode;
        data.yearMonth = this.Billform.yearMonth;
        data.inputType = "bInput";
      }
      //data = e=='Readingform'?this.Readingform.deviceCode:this.Billform.deviceCode
      GetByDeviceId(data).then((res) => {
        if (res.success) {
          if (this.activeName == "first") {
            that.Readingform.lastValue = res.result.curValue;
            if (res.result.curValueDate) {
              that.Readingform.lastValueDate =
                  res.result.curValueDate.substring(0, 10);
            }

            that.Readingform.deviceName = res.result.deviceName;
            that.Readingform.deviceId = res.result.deviceId;
            // that.Readingform.deviceType = res.result.deviceType
          } else {
            that.Billform.lastValue = res.result.curValue;
            that.Billform.lastValueDate = res.result.curValueDate;
            that.Billform.deviceName = res.result.deviceName;
            that.Billform.deviceId = res.result.deviceId;
            that.Billform.billNumber = res.result.billNumber;

            // that.Billform.deviceType = res.result.deviceType
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.SkipCount = (val - 1) * this.pageSize;
      this.getData();
    },
    handleClick() {
      this.SkipCount = 0;
      this.labList = [];
      this.getData();
    },

    windowClose() {
      this.formselect1 = {
        cityId: "",
        factoryId: "",
        buildingId: "",
        deviceTypeCode: "",
      };

      this.formArea = {
        DeviceName: "",
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      };
      this.dialogAddReading = false;
      this.dialogAddBill = false;
      this.showSelect = true;
    },
    //删除
    delMinput(e) {
      DeleteManualInputService(e).then((res) => {
        if (res.success) {
          this.$message.success("delete success");
          this.getData();
        }
      });
    },
    getData() {
      this.loading = true;
      var data = this.formselect,
          that = this;
      if (this.activeName == "first") {
        data.inputType = "mInput";
      } else {
        data.inputType = "bInput";
      }
      GetAllManualInputService(data, this.pageSize, this.SkipCount).then(
          (res) => {
            if (res.success) {
              //  
              if (this.activeName == "first") {
                that.tableData1 = JSON.parse(JSON.stringify(res.result.items));
              } else {
                that.tableData2 = JSON.parse(JSON.stringify(res.result.items));
              }
              that.total = res.result.totalCount;
              this.loading = false;
            }
          }
      );
    },
    onSubmitBill() {
      if (
          !this.Billform.deviceCode ||
          !this.Billform.curValue ||
          !this.Billform.includingPriceMonth ||
          !this.Billform.excludingPriceMonth
      ) {
        this.$message.warning(this.$t('PleaseFillItOutCompletely'));
        return;
      }
      var data = this.Billform;
      //data.curValueDate = getISOtime(data.curValueDate)
      data.curUsage = Number(data.curValue) - Number(data.lastValue);
      data.inputType = "bInput";
      if (this.clickBtn == "add") {
        delete data.id;
        CreateManualInputService(data).then((res) => {
          if (res.success) {
            this.$message.success("success");
            this.getData();
            this.dialogAddBill = false;
          }
        });
      } else {
        UpdateManualInputService(data).then((res) => {
          if (res.success) {
            this.$message.success("success");
            this.getData();
            this.dialogAddBill = false;
          }
        });
      }
    },
    onSubmit() {
;
      if (!this.Readingform.curValue) {
        this.$message.warning(this.$t('PleaseEnterTheCurrentReading'));
        return;
      } else if (!this.Readingform.deviceCode) {
        this.$message.warning(this.$t('PleaseSelectTheDeviceCode'));
        return;
      }

      var data = this.Readingform;
      data.curValueDate = getISOtime(data.curValueDate);
      data.curUsage = Number(data.curValue) - Number(data.lastValue);
      data.inputType = "mInput";
      if (this.clickBtn == "add") {
        delete data.id;
        CreateManualInputService(data).then((res) => {
          if (res.success) {
            this.$message.success("success");
            this.getData();
            this.dialogAddReading = false;
          }
        });
      } else {
        UpdateManualInputService(data).then((res) => {
          if (res.success) {
            this.$message.success("success");
            this.getData();
            this.dialogAddReading = false;
          }
        });
      }
    },
    getFac() {
  
      var a = "";

      this.area.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });

      this.facList = this.area[a].children;
      this.building = [];
      this.labList = [];
    },
    getBuild() {

      var a = "";

      this.facList.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      this.building = this.facList[a].children;
      this.labList = [];
    },
    getLab() {

      var a = "";
      this.building.map((item, index) => {
        if (id == item.value) {
          a = index;
        }
      });
      this.labList = this.building[a].children;
    },
  },
};
</script>

<style scoped>
</style>
